// App header — MOBILE ONLY. On desktop the sidebar carries the logo and
// the account cluster (Profile / Settings / Log out), so there is no top
// bar at all. On mobile this slim paper bar exists purely to open the
// nav drawer and the AI chat.

import { Menu, MessageCircle } from 'lucide-react'
import { useGlobalState } from '@/stores/globalState'
import { useIsDesktop } from '@/hooks/useMediaQuery'
import { ASK_HOPSCOTCH } from '@/lib/featureFlags'
import './styles/AppHeader.css'

export function AppHeader() {
  const toggleLeftPanel = useGlobalState((s) => s.toggleLeftPanel)
  const toggleRightPanel = useGlobalState((s) => s.toggleRightPanel)
  const isDesktop = useIsDesktop()

  if (isDesktop) return null

  return (
    <header className="hs-brand sticky top-0 z-40 flex h-14 shrink-0 items-center px-4 app-header">
      <button
        type="button"
        onClick={toggleLeftPanel}
        className="mr-3 flex h-9 w-9 items-center justify-center rounded-md app-header__icon-button"
        aria-label="Open navigation menu"
      >
        <Menu className="h-5 w-5" />
      </button>

      <div className="app-header__brand">
        <span className="app-header__mark" />
        <span className="app-header__name">Hopscotch</span>
      </div>

      <div className="flex-1" />

      {/* The Ask Hopscotch companion brings its own launchers (edge handle /
          corner pill), so the header chat toggle only serves the legacy panel. */}
      {!ASK_HOPSCOTCH && (
        <button
          type="button"
          onClick={toggleRightPanel}
          className="ml-3 flex h-9 w-9 items-center justify-center rounded-md app-header__icon-button"
          aria-label="Open AI chat"
        >
          <MessageCircle className="h-5 w-5" />
        </button>
      )}
    </header>
  )
}
